import { useTheme } from '@mui/material';

export const IconAppSelection = () => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            width="102"
            height="62"
            viewBox="0 0 102 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill="#ACAFB5"
                fillOpacity={0.2}
                d="M18.976.606v40.727h-8.61V8.78h-.239L.8 14.626V6.99L10.883.606h8.093Z"
            />
            <mask id="a" fill="white">
                <path
                    fillRule="evenodd"
                    d="M21.358 16a4 4 0 0 1 4-4H38.69a4 4 0 0 1 4 4v13.333a4 4 0 0 1-4 4H25.358a4 4 0 0 1-4-4V16Zm0 28.444a4 4 0 0 1 4-4H38.69a4 4 0 0 1 4 4v13.334a4 4 0 0 1-4 4H25.358a4 4 0 0 1-4-4V44.444Zm33.333-4a4 4 0 0 0-4 4v13.334a4 4 0 0 0 4 4h13.334a4 4 0 0 0 4-4V44.444a4 4 0 0 0-4-4H54.69Zm25.334 4a4 4 0 0 1 4-4h13.333a4 4 0 0 1 4 4v13.334a4 4 0 0 1-4 4H84.024a4 4 0 0 1-4-4V44.444Zm4-32.444a4 4 0 0 0-4 4v13.333a4 4 0 0 0 4 4h13.333a4 4 0 0 0 4-4V16a4 4 0 0 0-4-4H84.024Z"
                    clipRule="evenodd"
                />
            </mask>
            <path
                fill="white"
                fillRule="evenodd"
                d="M21.358 16a4 4 0 0 1 4-4H38.69a4 4 0 0 1 4 4v13.333a4 4 0 0 1-4 4H25.358a4 4 0 0 1-4-4V16Zm0 28.444a4 4 0 0 1 4-4H38.69a4 4 0 0 1 4 4v13.334a4 4 0 0 1-4 4H25.358a4 4 0 0 1-4-4V44.444Zm33.333-4a4 4 0 0 0-4 4v13.334a4 4 0 0 0 4 4h13.334a4 4 0 0 0 4-4V44.444a4 4 0 0 0-4-4H54.69Zm25.334 4a4 4 0 0 1 4-4h13.333a4 4 0 0 1 4 4v13.334a4 4 0 0 1-4 4H84.024a4 4 0 0 1-4-4V44.444Zm4-32.444a4 4 0 0 0-4 4v13.333a4 4 0 0 0 4 4h13.333a4 4 0 0 0 4-4V16a4 4 0 0 0-4-4H84.024Z"
                clipRule="evenodd"
            />
            <path
                fill="#7F8898"
                d="M25.358 11a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3v-2Zm13.333 0H25.358v2H38.69v-2Zm5 5a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3h2Zm0 13.333V16h-2v13.333h2Zm-5 5a5 5 0 0 0 5-5h-2a3 3 0 0 1-3 3v2Zm-13.333 0H38.69v-2H25.358v2Zm-5-5a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3h-2Zm0-13.333v13.333h2V16h-2Zm5 23.444a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3v-2Zm13.333 0H25.358v2H38.69v-2Zm5 5a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3h2Zm0 13.334V44.444h-2v13.334h2Zm-5 5a5 5 0 0 0 5-5h-2a3 3 0 0 1-3 3v2Zm-13.333 0H38.69v-2H25.358v2Zm-5-5a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3h-2Zm0-13.334v13.334h2V44.444h-2Zm31.333 0a3 3 0 0 1 3-3v-2a5 5 0 0 0-5 5h2Zm0 13.334V44.444h-2v13.334h2Zm3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5v-2Zm13.334 0H54.69v2h13.334v-2Zm3-3a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5h-2Zm0-13.334v13.334h2V44.444h-2Zm-3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5v2Zm-13.334 0h13.334v-2H54.69v2Zm29.334-2a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3v-2Zm13.333 0H84.024v2h13.334v-2Zm5 5a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3h2Zm0 13.334V44.444h-2v13.334h2Zm-5 5a5 5 0 0 0 5-5h-2a3 3 0 0 1-3 3v2Zm-13.334 0h13.334v-2H84.024v2Zm-5-5a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3h-2Zm0-13.334v13.334h2V44.444h-2Zm2-28.444a3 3 0 0 1 3-3v-2a5 5 0 0 0-5 5h2Zm0 13.333V16h-2v13.333h2Zm3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5v-2Zm13.334 0H84.024v2h13.334v-2Zm3-3a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5h-2Zm0-13.333v13.333h2V16h-2Zm-3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5v2Zm-13.334 0h13.334v-2H84.024v2Z"
                mask="url(#a)"
            />
            <path
                fill="#F8F8F8"
                fillRule="evenodd"
                d="M40.024 22.667a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm0 28.444a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm21.334 8a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm37.333-8a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-20.444a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
                clipRule="evenodd"
            />
            <g filter="url(#b)" opacity={0.5}>
                <rect
                    width={17.778}
                    height={17.778}
                    x={52.469}
                    y={17.333}
                    fill={primaryIconStrokeColor}
                    rx={4}
                />
            </g>
            <rect
                width={21.333}
                height={21.333}
                x={50.691}
                y={12}
                fill={primaryIconStrokeColor}
                rx={4}
            />
            <path
                fill="white"
                fillRule="evenodd"
                d="M67.967 18.483a.889.889 0 0 0-1.257 0l-6.914 6.913-3.143-3.142a.889.889 0 0 0-1.257 1.257l3.767 3.767a.889.889 0 0 0 1.261.004l7.543-7.542a.889.889 0 0 0 0-1.257Z"
                clipRule="evenodd"
            />
            <path
                fill="white"
                stroke="#7F8898"
                d="M66.957 39.912c-2.49.172-4.956-11.437-3.262-13.13 1.693-1.695 13.303.77 13.131 3.26-.118 1.63-2.878 2.274-2.797 3.723.023.425.56.812 1.632 1.585.745.538 1.504 1.06 2.236 1.614a.906.906 0 0 1 .322.945 4.6 4.6 0 0 1-3.396 3.397.905.905 0 0 1-.945-.322c-.554-.733-1.076-1.492-1.614-2.237-.773-1.073-1.16-1.609-1.584-1.632-1.449-.08-2.093 2.679-3.723 2.797Z"
            />
            <defs>
                <filter
                    id="b"
                    width={25.778}
                    height={25.778}
                    x={48.469}
                    y={13.333}
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur_3213_2135" />
                </filter>
            </defs>
        </svg>
    );
};

export default IconAppSelection;
